import React, { useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { AppButton } from '.';
import { Box, List, ListItem, Link, IconButton, Tooltip } from "@mui/material";
import { styled } from '@mui/material/styles';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useDispatch } from 'react-redux';
import { logout } from '@/stores/authSlice';
import { AuthService } from '@/services';

const SidebarContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexFlow: 'column',
  width: '248px',
  backgroundColor: '#002F73',
  boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.25)',
  maxHeight: '100%',
  overflow: 'auto',
  '&.smallSidebar': {
    width: 74,
    '& .MuiButtonBase-root': {
      margin: 0,
      justifyContent: 'center',
    },
    '& .sidebarLogo': {
      paddingLeft: 0,
      paddingRight: 0,
      justifyContent: 'center',
      '& .logo': {
        display: 'none',
      },
    },
    '& .MuiListItem-root': {
      '& .MuiListItemIcon-root': {
        margin: 0,
      },
      '& .MuiListItemText-root': {
        display: 'none',
      }
    },
    '& .logBtn': {
      paddingLeft: 0,
      paddingRight: 0,
      '& .MuiButtonBase-root': {
        fontSize: 0,
        minWidth: 1,
        padding: theme.spacing(1.25),
        '& .MuiButton-icon': {
          margin: 0,
        },
      },
    },
    '& + .MuiBox-root': {
      maxWidth: 'calc(100% - 74px)',
    }
  }
}));

const SidebarList = styled(List)(() => ({
  padding: 0,
  width: '100%',
}));

const SidebarListItemButton = styled(ListItemButton)(({ theme }) => ({
  padding: theme.spacing(2, 2.5),
  color: '#fff',
  transition: '500ms',
  position: 'relative',
  '& .MuiListItemIcon-root': {
    filter: 'brightness(0) invert(1)',
    opacity: 1,
  },
  '&:hover': {
    backgroundColor: '#2B62B1',
  },
  '&.selected': {
    backgroundColor: '#2B62B1',
  },
}));

const SidebarListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  width: 24,
  minWidth: 24,
  filter: 'grayscale(1)',
  opacity: 0.6,
  transition: '500ms',
  marginRight: theme.spacing(1.25),
}));

const SidebarListItemText = styled(ListItemText)(() => ({
  margin: 0,
  // padding: 0,
  // '& .MuiListItemText-primary': {
  //   fontSize: 16,
  //   lineHeight: '20px',
  //   fontWeight: 400,
  //   transition: '500ms',
  // },
}));

const NavLogoutBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  padding: theme.spacing(2),
  marginTop: 'auto',
}));

const SidebarLogo = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  padding: theme.spacing(1, 2.5),
  position: 'sticky',
  top: 0,
  zIndex: 1,
  minHeight: 74,
  backgroundColor: theme.palette.primary.main,
}));


const CustomerSideBar: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isExpanded, setIsExpanded] = React.useState(false);

  const sidebarToggle = () => {
    setIsExpanded((prev) => !prev);
  };

  const isActive = (path?: string) => {
    if (!path) return false;
    // console.log(location.pathname, path);
    return location.pathname === path;
  };

  const handleLogout = () => {
    AuthService.logout({ token: localStorage.getItem('fcmToken') })
    dispatch(logout());
    navigate("/login");
  }

  // useEffect(()=>{
  //   navigate('/customer/tickets');
  // },[])

  const menuItems = [
    // { label: "Requests", icon: "/images/call-icon.svg", path: "/customer/requests" },
    { label: "Tickets", icon: "/images/tickets-icon2.svg", path: "/customer/tickets" },
    { label: "Feedback", icon: "/images/feedback-icon.svg", path: "/customer/feedbacks" },
    // { label: "Updates", icon: "/images/updates-icon.svg", path: "/customer/updates" },
  ];

  return (
    <SidebarContainer className={isExpanded ? 'smallSidebar' : ''}>
      <SidebarLogo className="sidebarLogo" sx={{gap: "5px"}}>
        <Link
          className="logo"
          onClick={() => navigate('/customer/tickets')}
           sx={{ display: 'inline-flex', '& img': { maxWidth: '100%', filter: 'brightness(0) invert(1)' } }}
        >
          <img src="/images/logo-2x.png" alt="Logo" />
        </Link>
        <IconButton sx={{ ml: 'auto' }} onClick={sidebarToggle}>
          <img src="/images/menu-bar.svg" alt="Menu" />
        </IconButton>
      </SidebarLogo>
      <nav aria-label="main mailbox folders" className="dashNavbar">
        <SidebarList>
          {menuItems.map((item, index) => (
            <ListItem disablePadding key={index} sx={{ '&:not(:first-of-type)': { mt: 1, } }}>
              <Tooltip title={item.label} placement="right">
                <SidebarListItemButton
                  onClick={() => navigate(item.path)}
                  className={isActive(item.path) ? "selected" : ""}
                >
                  <SidebarListItemIcon>
                    <img src={item.icon} alt={item.label} />
                  </SidebarListItemIcon>
                  <SidebarListItemText primary={item.label} />
                </SidebarListItemButton>
              </Tooltip>
            </ListItem>
          ))}
        </SidebarList>
      </nav>

      <NavLogoutBox className="logBtn">
        <AppButton
          className="light"
          onClick={() => handleLogout()}
          type="button"
          disableElevation
          variant="outlined"
          size="small"
          startIcon={<img src="/images/logout.svg" alt="Logout" />}
        >
          Logout
        </AppButton>
      </NavLogoutBox>
    </SidebarContainer>
  );
};

export default CustomerSideBar;
